import SubscribePlan from './inc/SubscribePlan';

if (document.querySelector('#payment-form') !== null) {
	new SubscribePlan(window.pageData.stripeKey, '#payment-form');
}
